(function () {
  'use strict';

  var ua = navigator.userAgent || '';
  var isInstagram = ua.indexOf('Instagram') !== -1;
  var isTikTok = ua.indexOf('musical_ly') !== -1 || ua.indexOf('TikTok') !== -1 || ua.indexOf('BytedanceWebview') !== -1;
  var isInAppBrowser = isInstagram || isTikTok;

  if (!isInAppBrowser) return;

  // Polyfill localStorage in-memory
  (function () {
    var memoryStorage = {};
    var canUseLocalStorage = false;
    try {
      localStorage.setItem('__test__', '1');
      localStorage.removeItem('__test__');
      canUseLocalStorage = true;
    } catch (e) {}

    if (!canUseLocalStorage) {
      var polyfill = {
        getItem: function (key) { return Object.prototype.hasOwnProperty.call(memoryStorage, key) ? memoryStorage[key] : null; },
        setItem: function (key, value) { memoryStorage[key] = String(value); },
        removeItem: function (key) { delete memoryStorage[key]; },
        clear: function () { memoryStorage = {}; },
        key: function (index) { return Object.keys(memoryStorage)[index] || null; },
        get length() { return Object.keys(memoryStorage).length; }
      };
      try {
        Object.defineProperty(window, 'localStorage', { value: polyfill, writable: false, configurable: true });
      } catch (e) { window.localStorage = polyfill; }
    }
  })();

  // Patch View Transitions API
  (function () {
    if (document.startViewTransition) {
      var orig = document.startViewTransition.bind(document);
      document.startViewTransition = function (callback) {
        try { return orig(callback); } catch (e) {
          if (typeof callback === 'function') {
            var r = callback();
            return { ready: Promise.resolve(), finished: Promise.resolve(r), updateCallbackDone: Promise.resolve(r), skipTransition: function () {} };
          }
        }
      };
    }
  })();

  // Patch redirect
  (function () {
    function safeNavigate(url) {
      try { window.location.href = url; } catch (e) {
        var a = document.createElement('a');
        a.href = url; a.target = '_self';
        document.body.appendChild(a); a.click(); document.body.removeChild(a);
      }
    }
    try { var origAssign = window.location.assign.bind(window.location); window.location.assign = function (url) { try { origAssign(url); } catch (e) { safeNavigate(url); } }; } catch (e) {}
    try { var origReplace = window.location.replace.bind(window.location); window.location.replace = function (url) { try { origReplace(url); } catch (e) { safeNavigate(url); } }; } catch (e) {}
  })();

})();
